import React from 'react';
import { KeyboardContainer, KeyboardRow, LetterButton } from './styles.js';

const Keyboard = ({ guessedLetters, onLetterClick, gameStatus, word }) => {
  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

  // Split alphabet into rows for better layout
  const keyboardRows = [
    alphabet.slice(0, 10), // A-J
    alphabet.slice(10, 19), // K-S
    alphabet.slice(19), // T-Z
  ];

  const handleLetterClick = letter => {
    if (gameStatus === 'playing' && !guessedLetters.has(letter)) {
      onLetterClick(letter);
    }
  };

  return (
    <KeyboardContainer>
      {keyboardRows.map((row, rowIndex) => (
        <KeyboardRow key={rowIndex}>
          {row.map(letter => {
            const isGuessed = guessedLetters.has(letter);
            const isCorrect = isGuessed && word.includes(letter);

            return (
              <LetterButton
                key={letter}
                onClick={() => handleLetterClick(letter)}
                disabled={isGuessed || gameStatus !== 'playing'}
                isGuessed={isGuessed}
                isCorrect={isCorrect}
                variant="contained"
                size="small"
              >
                {letter}
              </LetterButton>
            );
          })}
        </KeyboardRow>
      ))}
    </KeyboardContainer>
  );
};

export default Keyboard;
